import { v4 as uuidv4 } from 'uuid';
import generateContext, { createAction } from '..';
import notificationStorage from '@shared/services/notification-storage';
import { ReactNode } from 'react';
import useProgressiveWebApp from '@src/shared/hooks/use-pwa';
interface INotificationsState {
  maxDisplayedAtOnce: number;
  displayDuration: number;
  notificationsList: INotification[];
}

const initialState: INotificationsState = {
  maxDisplayedAtOnce: 2,
  displayDuration: 5000,
  notificationsList: [],
};

export interface INotification {
  id: string;
  type: NotificationType;
  message: string | ReactNode;
  categorie?: NotificationCategories,
  timestamp?: number,
  title?: string;
  seen?: Boolean,
  showOnlyInDrawer?: Boolean,
  encrypted?:Boolean
}

enum NotificationsActionType {
  ShowNotification = 'SHOW_NOTIFICATION',
  HideNotification = 'HIDE_NOTIFICATION',
}

export enum NotificationCategories {
  CourierManagement = 'COURIER_MANAGEMENT',
  Dashboard = 'DASHBOARD'
}

export enum NotificationType {
  Success = 'SUCCESS',
  Error = 'ERROR',
  Information = 'INFORMATION',
  Warning = 'WARNING'
}

const reducer = (
  state: INotificationsState,
  action: { type: NotificationsActionType; payload?: any }
): INotificationsState => {
  switch (action.type) {
    case NotificationsActionType.ShowNotification:
      return {
        ...state,
        notificationsList: [...state.notificationsList,action.payload],
      };
    case NotificationsActionType.HideNotification:
      return {
        ...state,
        notificationsList: state.notificationsList.filter(
          (item) => item.id !== action.payload
        ),
      };
    default:
      return state;
  }
};

const [
  NotificationsCtxProvider,
  useNotificationsState,
  useNotificationsDispatch,
] = generateContext(reducer, initialState);

const useNotificationsActions = (notificationCategorie?: NotificationCategories) => {
  const dispatch = useNotificationsDispatch();
  const { isAppInstalled } = useProgressiveWebApp()

  const notify = ({ message = '', title = '', type = NotificationType.Information, showOnlyInDrawer = false, seen = false }: { message: string, title: string, type: NotificationType, showOnlyInDrawer: Boolean, seen:Boolean }) => {
    const action = createAction(NotificationsActionType.ShowNotification, {
      id: uuidv4(),
      type,
      message,
      categorie: notificationCategorie,
      timestamp: Date.now(),
      title,
      seen,
      showOnlyInDrawer
    });

    if (!isAppInstalled) {
      navigator?.serviceWorker?.controller?.postMessage({
          notificationTitle: title,
          notificationMessage: message,
      });
    }

    dispatch(action);
  };

  const notifySuccess = (message: string, title?: string) => {
    const action = createAction(NotificationsActionType.ShowNotification, {
      id: uuidv4(),
      type: NotificationType.Success,
      message,
      categorie: notificationCategorie,
      timestamp: Date.now(),
      title,
      seen: true

    });

 /*    if (!isAppInstalled) {
      navigator?.serviceWorker?.controller?.postMessage({
          notificationTitle: title,
          notificationMessage: message,
      });
    } */

    dispatch(action);
  };

  const notifyError = (message: string, title?: string) => {
    const action = createAction(NotificationsActionType.ShowNotification, {
      id: uuidv4(),
      type: NotificationType.Error,
      message,
      categorie: notificationCategorie,
      timestamp: Date.now(),
      title,
      seen: true
    });

/*     if (!isAppInstalled) {
      navigator?.serviceWorker?.controller?.postMessage({
          notificationTitle: title,
          notificationMessage: message,
      });
    } */

    dispatch(action);
  };

  const notifyInformation = (message: string, title?: string) => {
    const action = createAction(NotificationsActionType.ShowNotification, {
      id: uuidv4(),
      type: NotificationType.Information,
      message,
      categorie: notificationCategorie,
      timestamp: Date.now(),
      title,
      seen: true
    });

/*     if (!isAppInstalled) {
      navigator?.serviceWorker?.controller?.postMessage({
          notificationTitle: title,
          notificationMessage: message,
      });
    } */

    dispatch(action);
  };

  const notifyWarning = (message: string, title?: string) => {
    const action = createAction(NotificationsActionType.ShowNotification, {
      id: uuidv4(),
      type: NotificationType.Warning,
      message,
      categorie: notificationCategorie,
      timestamp: Date.now(),
      title,
      seen: true
    });

/*     if (!isAppInstalled) {
      navigator?.serviceWorker?.controller?.postMessage({
          notificationTitle: title,
          notificationMessage: message,
      });
    } */

    dispatch(action);
  };

  const hideNotification = (id: string) => {
    const action = createAction(NotificationsActionType.HideNotification, id);

    dispatch(action);
  };

  return { notifySuccess, notifyError, notifyInformation, notifyWarning, notify, hideNotification };
};

export {
  NotificationsCtxProvider,
  useNotificationsState,
  useNotificationsActions,
};
